import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-document-request',
  templateUrl: './document-request.component.html',
  styleUrls: ['./document-request.component.scss']
})
export class DocumentRequestComponent implements OnInit {
  abbNo: string = null;
  calendarLocale = CALENDAR_LOCALE.TH;
  confirmMsg: string;
  confirmationNo: string = null;
  currentPage = 1;
  documentRequest: any;
  endDate: Date;
  itemsPerPage = 40;
  loading = false;
  maxDate: Date;
  minDate: Date;
  modal: NgbModalRef;
  requestNo: string = null;
  roomChoices = [];
  selectedDocumentRequest: number;
  selectedRoomType = null;
  selectedStatus = null;
  startDate: Date;
  stateAction: string;
  statusChoices = [];
  subs: Subscription;
  tableData = [];
  totalItems: number;

  @ViewChild('successContent')
  successContent: TemplateRef<any>

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private router: Router,
  ) {
    if (!environment.enabledCustomerRequest) {
      this.router.navigate(['/login']);
    }
  }

  ngOnInit() {
    this.subs = this.translateService.onLangChange.subscribe(
      () => {
        this.loadDropdown();
      }
    )
    this.loadDropdown();
    this.loadInitialData();
    this.search();
  }

  get currentLang(): string {
    return this.translateService.currentLang;
  }

  loadDropdown() {
    this.roomChoices = [
      { label: this.translateService.instant('COMMON.ALL'), value: null },
      { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.HOTEL'), value: 'hotel' },
      { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.DINNING'), value: 'dinning' },
    ]
    this.statusChoices = [
      { label: this.translateService.instant('COMMON.ALL'), value: null },
      { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.PENDING'), value: 'pending' },
      { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.DONE'), value: 'done' },
      { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.CANCELLED'), value: 'cancelled' },
    ]
    this.calendarLocale = this.translateService.currentLang === 'en'
    ? CALENDAR_LOCALE.EN
    : CALENDAR_LOCALE.TH
    this.search();
  }

  loadInitialData() {
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  getFilterParams() {
    return {
      page: this.currentPage,
      page_size: this.itemsPerPage,
      status: this.selectedStatus || '',
      room_type: this.selectedRoomType || '',
      request_no: this.requestNo || '',
      abb_no: this.abbNo || '',
      confirmation_no: this.confirmationNo || '',
      created_at_after: moment(this.startDate).format('YYYY-MM-DD'),
      created_at_before: moment(this.endDate).format('YYYY-MM-DD'),
    }
  }

  search() {
    this.loading = true;
    const payload = this.getFilterParams();
    this.apiService.getDocumentRequest(payload).subscribe(
      (res) => {
        this.tableData = res.results;
        this.totalItems = res.count;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error(err);
      }
    );
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  openDocumentRequestDetail(modalContent, id) {
    this.apiService.getDocumentResponseDetail(id).subscribe(
      (result) => {
        this.documentRequest = result;
        this.modal = this.modalService.open(modalContent, { size: 'lg', centered: true, windowClass: 'custom-modal' });
      },
      (error) => {
        console.error(error);
      }
    );
  }


  openConfirmationModal(modalContent, id, action) {
    this.stateAction = action;
    switch (action) {
      case 'cancel': {
        this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.CANCEL-CONFIRM')
        break;
      }
      case 'delete': {
        this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.DELETE-CONFIRM')
        break;
      }
      case 'restore': {
        this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.RESTORE-CONFIRM')
        break;
      }
      default: {
        return
      }
    }

    this.selectedDocumentRequest = id;
    this.modal = this.modalService.open(modalContent, {centered: true});
  }

  confirmAction() {
    let request$ = null;
    switch (this.stateAction) {
      case 'cancel': {
        request$ = this.apiService.cancelDocumentRequest(this.selectedDocumentRequest)
        break;
      }
      case 'delete': {
        request$ = this.apiService.deleteDocumentRequest(this.selectedDocumentRequest)
        break;
      }
      case 'restore': {
        request$ = this.apiService.restoreDocumentRequest(this.selectedDocumentRequest)
        break;
      }
      default: {
        return
      }
    }

    if (!request$) {
      return
    }

    request$.subscribe(
      () => {
        this.closeModal();
        this.modal = this.modalService.open(this.successContent, {centered: true});
      },
      (error) => {
        console.error(error);
      }
    );
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  clear() {
    this.selectedRoomType = null;
    this.selectedStatus = null;
    this.selectedDocumentRequest = null;
    this.requestNo = null;
    this.documentRequest = null;
    this.stateAction = null;
    this.loadInitialData();
    this.optionChange();
  }

  pageChanged() {
    this.search();
  }

  optionChange() {
    this.currentPage = 1;
    this.search();
  }

  closeModal(refresh?: boolean) {
    if (this.modal) {
      this.modal.close();
    }

    if (refresh) {
      this.search();
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request.component.ts